"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var HeaderDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: block;\n  min-height: ", "vh;\n  width: 100%;\n  background-image: url('", "');\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-image: ", ";\n"], ["\n  position: relative;\n  display: block;\n  min-height: ", "vh;\n  width: 100%;\n  background-image: url('", "');\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-image: ", ";\n"])), function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var imgURL = _a.imgURL;
    return imgURL;
}, function (_a) {
    var position = _a.position;
    return position;
});
var PrimaryHeader = function (_a) {
    var _b = _a.imgURL, imgURL = _b === void 0 ? '' : _b, _c = _a.height, height = _c === void 0 ? 50 : _c, _d = _a.position, position = _d === void 0 ? 'center' : _d, children = _a.children;
    return (jsx_runtime_1.jsx(HeaderDiv, __assign({ imgURL: imgURL, position: position, height: height }, { children: children }), void 0));
};
exports.PrimaryHeader = PrimaryHeader;
var templateObject_1;
//# sourceMappingURL=index.js.map